import React, { Component } from 'react';
import { Row, Col, Card, CardBody, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import axios from 'axios';
import "./dashboard.scss";
import { API_BASE_URL } from "../../../constants";

class StaffAttendance extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            message: '',
            status: '', // not_marked, checked_in, checked_out
            checkInTime: null,
            checkOutTime: null,
            elapsed: '',
            showConfirmation: false,
        };
        this.timerInterval = null;
    }

    componentDidMount() {
        this.getAttendanceStatus();
    }

    componentWillUnmount() {
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
        }
    }

    formatDuration = (seconds) => {
        const hrs = Math.floor(seconds / 3600);
        const mins = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;
        return `${hrs.toString().padStart(2, '0')}:${mins
            .toString()
            .padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    };

    startTimer = (checkIn, checkOut = null) => {
        if (this.timerInterval) clearInterval(this.timerInterval);

        const checkInDate = new Date();
        const [h, m, s] = checkIn.split(':');
        checkInDate.setHours(h, m, s, 0);

        this.timerInterval = setInterval(() => {
            const now = new Date();
            const diff = Math.floor((now - checkInDate) / 1000);
            this.setState({ elapsed: this.formatDuration(diff) });
        }, 1000);
    };

    getAttendanceStatus = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/attendance/my-attendance`, {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token")
                }
            });

            if (response.data.status === 'success') {
                const attendance = response.data.attendance;
                let status = 'not_marked';

                if (attendance) {
                    const { check_in, check_out } = attendance;
                    if (check_in && !check_out) status = 'checked_in';
                    else if (check_in && check_out) status = 'checked_out';

                    this.setState({ checkInTime: check_in, checkOutTime: check_out });

                    if (check_in && !check_out) {
                        this.startTimer(check_in, check_out);
                    }
                }

                this.setState({ status });
            }
        } catch (error) {
            console.error('Error fetching attendance status:', error);
        }
    }

    handleAttendance = async () => {
        const { status } = this.state;
        
        if (status === 'checked_in') {
            // Show confirmation modal for check out
            this.setState({ showConfirmation: true });
            return;
        }

        this.markAttendance();
    }

    markAttendance = async () => {
        this.setState({ 
            loading: true, 
            message: '',
            showConfirmation: false 
        });

        try {
            const response = await axios.post(`${API_BASE_URL}/attendance/mark`, {}, {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token")
                }
            });

            if (response.data.status === 'success' || response.data.status === 'info') {
                this.setState({ message: response.data.message });
                this.getAttendanceStatus(); // Refresh status
            } else {
                this.setState({ message: response.data.message });
            }
        } catch (error) {
            this.setState({ message: 'Error marking attendance' });
            console.error(error);
        } finally {
            this.setState({ loading: false });
        }
    }

    renderStatusText = () => {
        const { status } = this.state;
        switch (status) {
            case 'checked_in':
                return <span className="text-success">Checked In</span>;
            case 'checked_out':
                return <span className="text-danger">Checked Out</span>;
            case 'not_marked':
            default:
                return <span className="text-warning">Not Marked</span>;
        }
    }

    renderButton = () => {
        const { loading, status } = this.state;
        
        if (status === 'checked_in') {
            return (
                <Button
                    color="danger"
                    size="lg"
                    onClick={this.handleAttendance}
                    disabled={loading}
                >
                    {loading ? 'Processing...' : 'Check Out'}
                </Button>
            );
        } else {
            return (
                <Button
                    color="primary"
                    size="lg"
                    onClick={this.handleAttendance}
                    disabled={loading}
                >
                    {loading ? 'Processing...' : 'Check In'}
                </Button>
            );
        }
    }

    render() {
        const { message, elapsed, showConfirmation } = this.state;

        return (
            <React.Fragment>
                <Col lg={12}>
                    <Card>
                        <CardBody className="border-top text-center">
                            <Row>
                                <Col sm={12} className="mb-3">
                                    <h5>Attendance Status: {this.renderStatusText()}</h5>
                                    {elapsed && (
                                        <h6 className="text-muted">⏱ Time Since Check-In: {elapsed}</h6>
                                    )}
                                </Col>

                                <Col sm={12}>
                                    {this.renderButton()}
                                </Col>

                                <Col sm={12} className="mt-3">
                                    {message && (
                                        <div className={`alert alert-${message.includes('success') ? 'success' : 'info'}`}>
                                            {message}
                                        </div>
                                    )}
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>

                    {/* Check Out Confirmation Modal */}
                    <Modal isOpen={showConfirmation} centered toggle={() => this.setState({ showConfirmation: false })}>
                        <ModalHeader>Confirm Check Out</ModalHeader>
                        <ModalBody>
                            Are you sure you want to check out? This will record your working hours for today.
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={() => this.setState({ showConfirmation: false })}>
                                Cancel
                            </Button>
                            <Button color="danger" onClick={this.markAttendance}>
                                Confirm Check Out
                            </Button>
                        </ModalFooter>
                    </Modal>
                </Col>
            </React.Fragment>
        );
    }
}

export default StaffAttendance;